import { registerAction } from '../../Action'
import { deserializeJson } from '../../jsonApiDeserializer'

const LOAD_WORKFLOW = 'LOAD_WORKFLOW'

const reducer = (state = {}, action) => ({
  ...deserializeJson({ payload: action.payload, state }),
})

const loadWorkflow = registerAction(LOAD_WORKFLOW, { reducer })

export default loadWorkflow
